<p-toast></p-toast>
<div class="wrap-general-info pb-5">
    <div class="container">
        <div class="d-flex general-info-inner">
            <div class="group-img w-6 pr-2">
                <div class="d-flex justify-content-between">
                    <div *ngIf="item?.mediumPhoto?.length > 0" class="list-img">
                        <div (click)="showImage(img?.url)"
                            class="wrap-item-img d-flex justify-content-center align-items-center"
                            *ngFor="let img of item?.mediumPhoto">
                            <img src="{{ img?.url }}" alt="img">
                        </div>
                    </div>
                    <div *ngIf="!item?.mediumPhoto?.[0]" class="list-img">
                        <div class="wrap-item-img d-flex justify-content-center align-items-center">
                            <img src="src-adisco/assets/images/image-default.jpeg" alt="">
                        </div>
                    </div>
                    <div class="img-show d-flex justify-content-center align-items-center">
                        <!-- <img src="{{imgShow}}" alt=""> -->
                        <div class="wrap-img-zoom">
                            <lib-ngx-image-zoom class="mx-auto img custom-zoom" [thumbImage]="imgShow"
                                [fullImage]="imgShow" [magnification]="1.5" [enableScrollZoom]="false"
                                [enableLens]="true" [lensWidth]="100" [lensHeight]="100"
                                [circularLens]="false"></lib-ngx-image-zoom>
                        </div>
                    </div>
                </div>
            </div>
            <div class="group-info w-6 pl-2">
                <div *ngIf="item?.mercurialArticle" class="info-status mercurial">
                    <p class="text-status mb-0">
                        Ce produit n'a pas été créé par le fournisseur
                    </p>
                </div>

                <div class="info-status">
                    <div *ngIf="item?.productplatform" class="produit-plateforme-label">
                        Produit plateforme
                    </div>
                    
                    <p class="text-status mb-0">
                        STATUT : {{ item?.productOpenOrClosed?.value }}
                    </p>
                    <p class="date-ouvert">
                        <!-- <span *ngIf="item?.dateProductOpen">Date Produit Ouvert : {{ item?.dateProductOpen |
                            date:'dd/MM/yyyy' }}</span> -->
                        <span *ngIf="item?.dateProductClosed && item?.productOpenOrClosed?.value == 'FERMÉ'">Date
                            Produit Fermé : {{ item?.dateProductClosed |
                            date:'dd/MM/yyyy' }}</span>
                    </p>
                    <p *ngIf="item?.replacementProduct && item?.productOpenOrClosed?.value == 'FERMÉ'"
                        class="date-ouvert">Produit de remplacement :
                        <a [routerLink]="['/catalogues/product-detail', item?.replacementProduct?.uniqueId]"
                            class="font-bold underline" style="color: #0092CD; font-size: 15px;">
                            {{ item?.replacementProduct?.value }}
                        </a>
                    </p>
                </div>
                <!-- *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')" -->
                <div
                    *ngIf="roleUser != role.UserNoTarif"
                    [ngStyle]="item?.maximumPrice || item?.tgap || item?.deee || item?.applicationStartDate || item?.applicationEndDate ? {'border-bottom': '1px solid rgba(71, 71, 71, 0.3)'} : {}"
                    class="info-price">
                    <p *ngIf="item?.maximumPrice" class="price-current">{{item?.pricelevelMaximum?.value| renamePriceLevel}} :
                        {{item?.maximumPrice}}
                        € HT
                    </p>
                    <!-- <p class="price-before">Tarif antérieur achat au carton : 75,65 € HT</p> -->
                    <!-- <p *ngIf="item?.tgap" class="tgap">TGAP : {{ item?.tgap }} </p>
                    <p *ngIf="item?.deee" class="deee">DEEE : {{ item?.deee }} </p> -->
                    <p *ngIf="item?.maximumPrice && item?.updatingDate">Dernière mis à jour tarif : {{ item?.updatingDate |
                        date:'dd/MM/yyyy' }}</p>
                    <div>
                        <span *ngIf="item?.applicationStartDate">Date de début de validité : {{
                            item?.applicationStartDate |
                            date:'dd/MM/yyyy' }}
                        </span>
                        <span *ngIf="item?.applicationEndDate">
                            - Date de fin de validité : {{ item?.applicationEndDate | date:'dd/MM/yyyy' }}
                        </span>
                    </div>
                </div>
                <div class="info-more">
                    <a class="font-bold" (click)="sendClick($event)">Accéder aux caractéristiques</a>
                    <div class="d-flex align-items-center gap-2">
                        <p *ngIf="dataSupplier?.logo[0]?.url" class="mb-0">Fournisseur :</p>
                        <a [routerLink]="['/catalogues/suppliers', dataSupplier?.code]">
                            <img [src]="dataSupplier?.logo[0]?.url" alt="">
                        </a>
                    </div>
                    <p *ngIf="item?.brand" class="mb-2">Marque : <span>{{ item?.brand }}</span></p>
                    <p *ngIf="item?.supplierItemNumber" class="mb-2">Référence fournisseur : <span>{{
                            item?.supplierItemNumber }}</span></p>
                    <p *ngIf="item?.uniqueId" class="mb-2">Référence Adisco : <span>{{ item?.uniqueId }}</span></p>
                    <p *ngIf="item?.shortDescription">Description courte : <span>{{ item?.shortDescription }}</span></p>
                </div>
                <a (mouseover)="checkProductExitsCart($event,item)" *ngIf="userService.hasExtranetAccess('fonctions', 'comparateur-produit')"
                    class="btn-common btn-comparer" (click)="addProductToCompare(item?.id)">
                    <img class="non-hover" src="src-adisco/assets/images/icon/comparator-blue.svg" alt="">
                    <img class="hover" src="src-adisco/assets/images/icon/comparator.svg" alt="">
                    COMPARER
                </a>
            </div>
        </div>
    </div>
</div>
